// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"3f6ba6d2","81":"0f41d4ef","239":"bacda914","345":"cd6c8d68","488":"32c3fafd","951":"2a1b6c49","977":"1b6130ef"}[chunkId] + ".chunk.js";
};